import { object } from 'yup'
export { member as baseURL } from 'constants/apiBaseUrls'

export const Schema = object()

export const url = () => `v1/conditions`
